module.exports = __webpack_public_path__ + "img/1.f62ac9d9.jpg";